import type * as Theme from '#theme'
import type { MaybeRefOrGetter } from '#imports'
import { toValue, watch, useMobileApp } from '#imports'
import { toHexColor } from '../utils/toHexColor'

export const APP_COLOR_SCHEME_MESSAGE = 'color_scheme'

export const useNativeAppColorScheme = (theme: MaybeRefOrGetter<Theme.Theme>): void => {
    if (import.meta.server) return

    const { isMobileApp, postToApp } = useMobileApp()

    if (!isMobileApp) return

    watch(() => toValue(theme), (current) => {
        postToApp({
            type: APP_COLOR_SCHEME_MESSAGE,
            mode: current.dark ? 'dark' : 'light',
            background: toHexColor(current.colors.background),
        })
    }, { immediate: true })
}
